import * as ActionTypes from '../../../constants/actionTypes';
import initialState from './initialState';

export default function alertsReducer(state = initialState(), action) {
  switch (action.type) {
    case ActionTypes.APP_ALERT_LANDING_COUNTS:
      return {
        ...state,
        myTeamTodayCounts: action.payload.myTeamTodayCounts,
        myTeamThisWeekCounts: action.payload.myTeamWeeklyCounts || [],
        otherTeamsTodayCounts: action.payload.otherTeamsTodayCounts,
        otherTeamsThisWeekCounts: action.payload.otherTeamsWeeklyCounts || [],
        myTeamCustomCounts: action.payload.myTeamCustomCounts || [],
        otherTeamsCustomCounts: action.payload.otherTeamsCustomCounts || [],
      };
    case ActionTypes.APP_ALERT_ALERTS_SET:
      return {
        ...state,
        myTeamTodayAlerts: action.payload.myTeamToday
          ? action.payload.myTeamToday
          : state.myTeamTodayAlerts,
        myTeamThisWeekAlerts: action.payload.myTeamThisWeek
          ? action.payload.myTeamThisWeek
          : state.myTeamThisWeekAlerts,
        myTeamCustomAlerts: action.payload.myTeamCustom
          ? action.payload.myTeamCustom
          : state.myTeamCustomAlerts,
        otherTeamsTodayAlerts: action.payload.otherTeamsToday
          ? action.payload.otherTeamsToday
          : state.otherTeamsTodayAlerts,
        otherTeamsThisWeekAlerts: action.payload.otherTeamsThisWeek
          ? action.payload.otherTeamsThisWeek
          : state.otherTeamsThisWeekAlerts,
        otherTeamsCustomAlerts: action.payload.otherTeamsCustom
          ? action.payload.otherTeamsCustom
          : state.otherTeamsCustomAlerts,
      };
    case ActionTypes.APP_ALERT_CUSTOM_SET:
      return {
        ...state,
        myTeamCustomAlerts: action.payload.myTeamCustom
          ? action.payload.myTeamCustom
          : state.myTeamCustomAlerts,
        otherTeamsCustomAlerts: action.payload.otherTeamsCustom
          ? action.payload.otherTeamsCustom
          : state.otherTeamsCustomAlerts,
      };
    case ActionTypes.APP_ALERT_SUBSCRIPTIONS_SET:
      return {
        ...state,
        subscriptions: action.payload,
      };
    case ActionTypes.APP_ALERT_CLIENTS_SET:
      return { ...state, clients: action.payload };
    case ActionTypes.APP_ALERT_PROGRAMS_SET:
      return { ...state, programs: action.payload };
    case ActionTypes.APP_ALERT_PROJECTS_SET:
      return { ...state, projects: action.payload };
    case ActionTypes.APP_ALERT_SITES_SET:
      return { ...state, sites: action.payload };
    case ActionTypes.APP_ALERT_SEARCH_FOR_SUBSCRIBE_SET:
      return {
        ...state,
        alertsForSubscription: action.payload,
      };
    case ActionTypes.APP_ALERT_SUBSCRIPTION_INSERT_SUCCESS:
    case ActionTypes.APP_ALERT_SUBSCRIPTION_DELETE_SUCCESS:
      return {
        ...state,
        responseMessage: action.payload.ResultMessage,
        lastSubscriptionInserted: action.payload.InsertedId,
      };
    case ActionTypes.APP_ALERT_TEAMNAME_SET:
      return {
        ...state,
        selectedTeamName: action.payload,
      };
    case ActionTypes.APP_ALERT_DATERANGE_SET:
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    case ActionTypes.APP_ALERT_DATERANGEPICKER_SET:
      return {
        ...state,
        selectedDateRangePicker: action.payload,
      };
    case ActionTypes.REDUX_RESET:
      return {
        ...initialState,
      };
    case ActionTypes.ALERT_TYPE:
      return {
        ...state,
        selectedAlert: action.payload
      };
    default:
      return state;
  }
}
